export default __webpack_public_path__ + "static/media/offerSlides1.143271d2.png";